import { useQuery } from "react-query";

import { IParamsDirections } from "~/entity/Directions/model/shema";

import { useDirections } from "./useDirections";

export const useGetDirections = ({
  page,
  count,
  ActualOn,
  id,
}: IParamsDirections) => {
  const { directionsGet } = useDirections();

  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ["directions", page, count, ActualOn, id],
    queryFn: () => directionsGet({ page, count, ActualOn, id }),
    enabled: !!ActualOn,
  });
  return {
    data: data?.data?.items,
    total: data?.data?.total,
    isLoading,
    isError,
    refetch,
  };
};
